import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import Dialog from '@comp/Dialog/Dialog';
import { useIsMobile } from '@stores/AppCommonData';
import { Spacings } from '@styles/index';
import UseCredits from './UseCredits/UseCredits';
import UseCreditsMobile from './UseCredits/UseCreditsMobile';
import NotEnoughCredits from './NotEnoughCredits/NotEnoughCredits';
import NotEnoughCreditsMobile from './NotEnoughCredits/NotEnoughCreditsMobile';

const Modal = styled(Dialog)`
  &.MuiDialog-root {
    .MuiDialog-container {
      position: relative;
      .MuiPaper-root {
        width: 560px;
        padding: ${Spacings.SPACING_10B} ${Spacings.SPACING_12B};
        position: absolute;
        bottom: 0px;
        border-radius: ${Spacings.SPACING_2B};
        .MuiDialogContent-root,
        .MuiDialogActions-root {
          padding: 0px;
        }
        .MuiDialogActions-root {
          justify-content: center;
          & > :last-child {
            margin-left: ${Spacings.SPACING_4B};
          }
        }
      }
    }
  }
`;

const CreditsStep = ({
  show,
  onClose,
  enroll,
  goalUID,
  goalSlug,
  selectedCombatInfo
}) => {
  const isMobile = useIsMobile();
  const requiredCredits = selectedCombatInfo.enroll_credits || 0;
  const credits = useSelector(({ auth }) => auth.me?.credits || 0);
  const NoCredits = isMobile ? NotEnoughCreditsMobile : NotEnoughCredits;
  const UsingCredits = isMobile ? UseCreditsMobile : UseCredits;
  return (
    <>
      {credits >= requiredCredits && (
        <UsingCredits
          Modal={Modal}
          show={show}
          onClose={onClose}
          requiredCredits={requiredCredits}
          credits={credits}
          enroll={enroll}
        />
      )}
      {credits < requiredCredits && (
        <NoCredits
          Modal={Modal}
          show={show}
          onClose={onClose}
          requiredCredits={requiredCredits}
          goalUID={goalUID}
          goalSlug={goalSlug}
          selectedCombatInfo={selectedCombatInfo}
        />
      )}
    </>
  );
};

CreditsStep.propTypes = {
  show: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  enroll: PropTypes.func.isRequired,
  goalUID: PropTypes.string.isRequired,
  goalSlug: PropTypes.string.isRequired,
  selectedCombatInfo: PropTypes.objectOf(PropTypes.any).isRequired
};

export default CreditsStep;
